import {useLevelOrder} from "@hooks/LevelOrder";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";

import styles from "./styles.module.scss";

export const ChatDesc = () => {
  const location = useLocation();
  const {t} = useTranslation();
  const {currentLevel} = useLevelOrder();

  const {type, level, name} = location?.state?.desc || {};

  return (
    <div className={styles.chatDesc}>
      <RootDesc>
        <span>
          {type === "certification"
            ? t("page.simulations.tab.certification")
            : type === "scenario"
              ? t("page.simulations.tab.call")
              : t("page.simulations.tab.product")}
        </span>
      </RootDesc>

      <h4>{name}</h4>

      {type !== "certification" && (
        <h6>
          {t("table.level")}: {currentLevel(level)}
        </h6>
      )}
    </div>
  );
};
